import { FC } from 'react'

import { pdf } from '@react-pdf/renderer'
import styled from 'styled-components'

import Eye from 'src/Assets/eye.svg?react'
import Download from 'src/Assets/download-pc.svg?react'
import { IconButton } from 'src/Components/Button/IconButton.tsx'
import { colors } from 'src/Helpers/constants.ts'
import { Offer } from 'src/Components/Offer'
import { OfferFormData } from 'src/Pages/Calculator/helpers.ts'
import { OfferModelUnit } from 'src/Pages/Calculator/useCalculator.tsx'

const StyledButton = styled(IconButton)`
  background-color: ${colors.fourthBlue} !important;

  &:hover {
    background-color: ${colors.fourthBlue} !important;
  }
`

const StyledButtonDownload = styled(IconButton)`
  background-color: ${colors.fourthBlue} !important;

  &:hover {
    background-color: ${colors.fourthBlue} !important;
  }

  svg {
    width: 25px;
    height: 25px;
    path {
      stroke: ${colors.white} !important;
    }
  }
`

export interface DownloadPdfButtonProps {
  offerEquipments?: Array<{
    imageUrl: string
    name: string
    typeLabel?: string
    modelName?: string
    characteristics: string
    quantity: number
    priceWithVat: string
    priceWithoutVat: string
    route: string
    workHoursMonthShifts: number
    partDeliveryPrice: number
    shiftsCount: number
    detalization: boolean
    baseRentalCost: number
    accommodationPrice: number
    foodPrice: number
    personnelHouseholdServicesCost: number
    fuelPrice: number
    fuelConsumption: number
    personDeliveryPrice: number
    relocationCost?: number
    units?: OfferModelUnit[]
    dailyMedCheckCost: number
    toolName?: string
    toolWorkPrice?: number
    vatVisibility: OfferFormData['vatVisibility']
  }>
  offerDate: string
  clientContactName?: string
  clientContactNamePosition?: string
  clientName?: string
  clientDivision?: string
  minRentPeriod: number
  offerNumber?: string
  validityDaysCount?: number
  withoutMedicalExamination?: boolean
  isWorkService?: boolean
  personalBenefits?: boolean
  privilegesData?: Array<string>
  introductionText?: string
  firstName: string
  lastName: string
  email: string
  phone: string
  disabled?: boolean
  isMobDemob?: boolean
  vatRate?: number
}

function downloadURI(uri: string, name: string): void {
  const link = document.createElement('a')
  link.href = uri
  link.download = name
  link.click()
}

export const DownloadPdfButton: FC<DownloadPdfButtonProps> = ({
  offerEquipments = [],
  offerNumber,
  clientContactName,
  clientContactNamePosition,
  clientName,
  clientDivision,
  minRentPeriod,
  validityDaysCount,
  withoutMedicalExamination,
  isWorkService,
  personalBenefits,
  privilegesData,
  introductionText,
  firstName,
  lastName,
  email,
  phone,
  offerDate,
  disabled,
  isMobDemob,
  vatRate,
}) => {
  const handleDownload = async (action: string): Promise<void> => {
    if (disabled) return

    let url = ''
    try {
      const blob = await pdf(
        <Offer
          offerDate={offerDate}
          offerNumber={offerNumber}
          offerEquipments={offerEquipments}
          clientContactName={clientContactName}
          clientContactNamePosition={clientContactNamePosition}
          clientName={clientName}
          clientDivision={clientDivision}
          minRentPeriod={minRentPeriod}
          validityDaysCount={validityDaysCount}
          withoutMedicalExamination={withoutMedicalExamination}
          isWorkService={isWorkService}
          personalBenefits={personalBenefits}
          privilegesData={privilegesData}
          introductionText={introductionText}
          firstName={firstName}
          lastName={lastName}
          email={email}
          phone={phone}
          isMobDemob={isMobDemob}
          vatRate={vatRate}
        />,
      ).toBlob()
      url = URL.createObjectURL(blob)

      if (action === 'download') {
        downloadURI(url, `filename.pdf`)
        return
      }

      window.open(url, '_blank')
    } catch {
      // Ошибки обрабатываются вызывающим кодом
    } finally {
      if (url) URL.revokeObjectURL(url)
    }
  }

  return (
    <>
      <StyledButton
        onClick={() => {
          handleDownload('watch')
        }}
        disabled={disabled}
        tooltiptext={disabled ? 'Сохраните КП перед просмотром' : 'Просмотр КП'}
        data-testid='preview-offer-pdf'
      >
        <Eye />
      </StyledButton>
      <StyledButtonDownload
        onClick={() => {
          handleDownload('download')
        }}
        disabled={disabled}
        tooltiptext={disabled ? 'Сохраните КП перед просмотром' : 'Скачать КП'}
        data-testid='download-offer-pdf'
      >
        <Download />
      </StyledButtonDownload>
    </>
  )
}
